import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Seller } from './seller';

/**
 * Query Seller (Fisherman) service.
 *
 * @author Warlock, AIS.PL
 */
@Injectable({
  providedIn: 'root'
})
export class QuerySellersService {

  constructor(private http: HttpClient) {
  }

  querySellers(text: string): Observable<Seller[]> {
    let params = new HttpParams();

    if (text !== '') {
      params = params.set('q', String(text));
    }

    return this.http
      .get('fishers/', { headers: { 'Content-Type': 'application/json' }, params: params })
      .pipe(
        map(response => response ? (response as any[]).map(element => Seller.fromJSON(element)) : null)
      );
  }

}
